import React from "react";
import { Grid, Button } from "@mantine/core";

const SelectorButton = (props: {
  data: { value: string; label: string; subLabel?: string }[];
  selected: string;
  onSubmit: (value: any) => void;
}) => {
  return (
    <Grid>
      {(props.data ?? []).map(
        (item: { value: string; label: string; subLabel?: string }) => {
          return (
            <Grid.Col span={6} key={item.value}>
              <Button
                variant="light"
                color={item.value === props.selected ? "blue" : "gray"}
                styles={
                  item.subLabel
                    ? {
                        label: {
                          whiteSpace: "normal",
                          height: "auto",
                          display: "block",
                          textBoxTrim: "none",
                          overflow: "visible",
                        },
                      }
                    : undefined
                }
                style={() => ({
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  height: "100%",
                  padding: "15px",
                  border:
                    item.value === props.selected ? "2px solid #228be6" : "0",
                })}
                onClick={() => props.onSubmit(item.value)}
              >
                {item.subLabel ? (
                  <span style={{ display: "block", lineHeight: 1.25 }}>
                    {item.label}
                    <br />
                    {item.subLabel}
                  </span>
                ) : (
                  item.label
                )}
              </Button>
            </Grid.Col>
          );
        }
      )}
    </Grid>
  );
};

export default SelectorButton;
